import { PropertyMeta } from 'bernie-http';
import loadable from '@loadable/component';
var TravelCreatorController = /** @class */function () {
  function TravelCreatorController() {
    this.pageId = 'page.travel-creator.home';
    /**
     * The "/" path is registered so client hydration works correctly when loading creator.expedia.com/
     * There is a lobot url rewrite rule for /creator/travel-creator to / when on the creator domain
     * https://lobot.expedia.biz/highlander/requestModifierRules/1149
     * A user going to affiliates.expediagroup.com/ will still be redirected to affiliates.expediagroup.com/home
     * because the hapi redirect occurs before Bernie takes over
     */
    this.path = ['/creator/travel-creator', '/'];
    this.legacyPath = '/:localeName/travel-creator';
    this.routeName = 'travel-creator';
    this.bundles = [];
    this.component = loadable(
    /* istanbul ignore next */
    {
      resolved: {},
      chunkName() {
        return "travel-creator";
      },
      isReady(props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function () {
        return import(/* webpackChunkName: "travel-creator" */'./travel-creator.view');
      },
      requireAsync(props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(resolved => {
          this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync(props) {
        const id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("./travel-creator.view");
        }
        return eval('require.resolve')("./travel-creator.view");
      }
    });
    this.exact = true;
  }
  TravelCreatorController.prototype.fetch = function () {
    return Promise.resolve({});
  };
  TravelCreatorController.prototype.fetchPageData = function () {
    var ogType = new PropertyMeta('og:type', 'website');
    var ogUrl = new PropertyMeta('og:url', "https://creator.expedia.com");
    var ogTitle = new PropertyMeta('og:title', 'Travel Creator Program');
    var ogDescription = new PropertyMeta('og:description', 'Curate and share content effortlessly, get featured, and access top travel brands like Expedia, Hotels.com, and Vrbo to expand your reach.');
    var ogImage = new PropertyMeta('og:image', 'https://affiliates.expediagroup.com/images/travel-creator-landing/og-image.png');
    var additionalMeta = [ogType, ogUrl, ogTitle, ogDescription, ogImage];
    var pageData = {
      title: 'Travel Creator Program – Expedia',
      seo: {
        canonical: "https://affiliates.expediagroup.com/creator/travel-creator",
        description: '',
        robots: 'index,follow',
        additionalMeta: additionalMeta
      }
    };
    return Promise.resolve(pageData);
  };
  return TravelCreatorController;
}();
export { TravelCreatorController };